import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export type SwitchSelectionMode = 'company' | 'branch';

export interface SwitchSelectionItem {
    id: string;
    name?: string;
    companyCode?: string;
    code?: string;
    logo?: string;
}

export interface SwitchSelectionDialogData {
    mode: SwitchSelectionMode;
    title: string;
    items: SwitchSelectionItem[];
    currentId: string | null;
}

@Component({
    selector: 'switch-selection-dialog',
    templateUrl: './switch-selection-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
})
export class SwitchSelectionDialogComponent {
    selectedId: string | null = null;

    constructor(
        private _dialogRef: MatDialogRef<SwitchSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SwitchSelectionDialogData
    ) {}

    /** Whether an item is the one the user is already using (and therefore disabled). */
    isCurrent(item: SwitchSelectionItem): boolean {
        return !!this.data.currentId && item.id === this.data.currentId;
    }

    /** Secondary line under the item name (company code or branch code). */
    subtitle(item: SwitchSelectionItem): string {
        return this.data.mode === 'company'
            ? item.companyCode ?? ''
            : item.code ?? '';
    }

    select(item: SwitchSelectionItem): void {
        if (this.isCurrent(item)) {
            return;
        }
        this.selectedId = item.id;
    }

    confirm(): void {
        if (!this.selectedId) {
            return;
        }
        this._dialogRef.close(this.selectedId);
    }

    cancel(): void {
        this._dialogRef.close();
    }
}
